import { m, AnimatePresence, LazyMotion, domAnimation } from "framer-motion"
import React, { useState } from "react"
import { Container, Row, Col } from "react-bootstrap"
import { StructuredText } from "react-datocms"

import Heading from "../../../utils/OptimizedHeading"
import Icon from "../../Icon/Icon"
import { Button } from "../styles/SlideBox.styled"
import { StandardSlideWrap } from "../styles/SlideStandard.styled"

import StandardContent from "./StandardContent"

const SlideStandard = ({
  component,
  grid,
  bgClass,
  cardVariants,
  activeSlideIndex,
  handleSwitcher,
}) => {
  const [selected, setSelected] = useState(null)

  return (
    <StandardSlideWrap
      className={`bg-${bgClass} container-${
        grid !== "" ? grid?.toLowerCase() : "normal"
      } ${component?.floatabove ? "floatabove" : ""} ${
        component?.bottomPadding ? "bottom-padding" : ""
      } ${component?.topPadding ? "top-padding" : ""}`}
    >
      <Container>
        <Row>
          <Col>
            <div className="heading-container mb-5">
              {component?.eyebrow && (
                <p className="heading-kicker eyebrow">{component?.eyebrow}</p>
              )}
              {component?.heading && (
                <Heading
                  type={component?.headingSize}
                  string={component?.heading}
                  className="heading"
                />
              )}
              {component?.slideBoxBody && (
                <div className="description">
                  <StructuredText
                    data={component?.slideBoxBody}
                    renderInlineRecord={() => {}}
                  />
                </div>
              )}
            </div>
            <div className="main-container horizontal-tabs">
              <div className="tabs-area">
                {component?.slide &&
                  component?.slide.map((item, index) => (
                    <Button
                      key={index}
                      className={
                        activeSlideIndex === index ? "active-button" : ""
                      }
                      onClick={() => handleSwitcher(index)}
                    >
                      {item?.iconSelect && (
                        <Icon
                          id={item?.iconSelect}
                          active={activeSlideIndex === index}
                          size={40}
                          theme="grayBlue"
                          classes={activeSlideIndex === index && `active`}
                        />
                      )}
                      {item?.label}
                    </Button>
                  ))}
              </div>
              <AnimatePresence mode="wait" initial={true}>
                <LazyMotion features={domAnimation}>
                  <m.div
                    key={activeSlideIndex}
                    variants={cardVariants}
                    initial="enter"
                    animate="center"
                    exit="exit"
                    transition={{ duration: 0.3 }}
                  >
                    {component?.slide &&
                      component?.slide.map((item, idx) => (
                        <StandardContent
                          key={idx}
                          idx={idx}
                          item={item}
                          selected={selected}
                          setSelected={setSelected}
                          activeSlideIndex={activeSlideIndex}
                        />
                      ))}
                  </m.div>
                </LazyMotion>
              </AnimatePresence>
            </div>
          </Col>
        </Row>
      </Container>
    </StandardSlideWrap>
  )
}

export default SlideStandard
